import "./Events.css";

function Events()
{
    return(
        <>
            <div className = "desktop">
                <div className = "events">
                    <div className = "block">
                        <h1 style = {{ color : '#28CED2' }} >&emsp;&nbsp;Pro Shows and DJ Nights</h1>
                        <div className = "main_content">
                            <div className = "text">
                                Festember is not only about competition and team work. 
                                It is about enjoying the peaceful 3 days of academic year. 
                                Lets not make it simple and decent. We have <b>PRO SHOWs</b> and <b>DJ NIGHTs</b> every year to make you night memorable. 
                                Don’t keep you back lied in the bed and be lazy. 
                                Make your mood swing with songs and lights in the DJ Night and Pro Shows that are coming up every year. 
                                May be, if you miss it and stay back, you might not get it back anytime ahead. 
                                So, throws your books and get you legs on air.
                            </div>
                            <div className = "spacer"></div>
                            <div className = "images">
                                <img src = "/Resources/Karthik_Concert.jpg" alt = "err" />
                                <img src = "/Resources/DJ_Nights.jpg" alt = "err" />
                            </div>
                        </div>
                    </div>
                    <br/><br/>
                    <div className = "border"></div>
                    <br/><br/>
                    <div className = "block">
                        <h1 style = {{ color : '#9640EC' }} >&nbsp;&nbsp;&nbsp;Guest Lectures</h1>
                        <div className = "main_content">
                            <div className = "images">
                                <img src = "/Resources/Maari_Selvaraj.avif" alt = "err" />
                                <img src = "/Resources/Vettaiyan.jpg" alt = "err" />
                            </div>
                            <div className = "spacer"></div>
                            <div className = "text">
                                Not just fun, but we have our Festember fun filled with our guests. 
                                Let’s not miss Maari Selvaraj, one of the famous directors in the Tamil Film Industry. 
                                Let’s not miss Rakshan, Dushaara and Rithika Singh from Vettaiyan. 
                                Let’s not miss one of the famous independent music directors in the industry, well known as HipHop Thamizha. 
                                And what not, we have Raghava Lawerence, SJ Surya and Harris Jayaraj featuring the Festember with their all time special Jigarthanda Double X.
                            </div>
                        </div>
                    </div>
                    <br/><br/>
                    <div className = "border"></div>
                    <br/><br/>
                </div>
            </div>
            <div className = "mobile">
                <div className = "events">
                    <div className = "block">
                        <h1 style = {{ color : '#28CED2' }} >Pro Shows and DJ Nights</h1>
                        <div className = "main_content">
                            <div className = "images">
                                <img src = "/Resources/Karthik_Concert.jpg" alt = "err" />
                            </div>
                            <div className = "text">
                                Festember is not only about competition and team work. 
                                It is about enjoying the peaceful 3 days of academic year. 
                                Lets not make it simple and decent. We have <b>PRO SHOWs</b> and <b>DJ NIGHTs</b> every year to make you night memorable. 
                                Don’t keep you back lied in the bed and be lazy. 
                                Make your mood swing with songs and lights in the DJ Night and Pro Shows that are coming up every year. 
                                May be, if you miss it and stay back, you might not get it back anytime ahead. 
                                So, throws your books and get you legs on air.
                            </div>
                        </div>
                    </div>
                    <br/><br/>
                    <div className = "border"></div>
                    <br/><br/>
                    <div className = "block">
                        <h1 style = {{ color : '#9640EC' }} >Guest Lectures</h1>
                        <div className = "main_content">
                            <div className = "images">
                                <img src = "/Resources/Vettaiyan.jpg" alt = "err" />
                            </div>
                            <div className = "text">
                                Not just fun, but we have our Festember fun filled with our guests. 
                                Let’s not miss Maari Selvaraj, one of the famous directors in the Tamil Film Industry. 
                                Let’s not miss Rakshan, Dushaara and Rithika Singh from Vettaiyan. 
                                Let’s not miss one of the famous independent music directors in the industry, well known as HipHop Thamizha. 
                                And what not, we have Raghava Lawerence, SJ Surya and Harris Jayaraj featuring the Festember with their all time special Jigarthanda Double X.
                            </div>
                        </div>
                    </div>
                    <br/><br/>
                    <div className = "border"></div>
                    <br/><br/>
                </div>
            </div>
        </>
    );
}

export default Events;